// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style-module_markdown__1HmA5uCWYAnq8Ut9ORdUPb","secondaryText":"style-module_secondaryText__2QXczyXZYPAS4gfvJKLlRF"};